import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    src: string;
    title: string;
}

export const ShieldMobile: FC<IProps> = ({src, title}) => {
    return (
        <div className={style.main}>
            <img alt={title} className={style.image} src={src} />
            <Typography className={style.title} variant={'label-14-r-fluid'}>
                {title}
            </Typography>
        </div>
    );
};
